import cx from 'classnames'
import LoadingStyles from './LoadingState.module.scss'
import Styles from '../NotificationItem/NotificationItem.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const LoadingState = () => {
  return (
    <div className={cx(Styles.container, LoadingStyles.container)}>
      <div className={cx(Styles.user, LoadingStyles.user)}>
        <Skeleton
          className={cx(Styles.userName, LoadingStyles.paragraph)}
          active
          avatar={{ size: 36, shape: 'circle' }}
          paragraph={{ rows: 3, width: 250 }}
          title={false}
        />
      </div>
    </div>
  )
}
